// UserIcons.tsx
import React from "react";
import {
  Box,
  Typography,
  useTheme,
  SvgIcon,
  SvgIconProps,
} from "@mui/material";
import {
  LocationOn as LocationOnIcon,
  School as SchoolIcon,
} from "@mui/icons-material";

// Industries & Disciplines Icon
export const IndustriesIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 34.398 31.956">
      <g
        id="Industries_Disciplines_icon"
        data-name="Industries &amp; Disciplines icon"
        transform="translate(0 0)"
      >
        <g id="Group_1768" data-name="Group 1768" transform="translate(0 0)">
          <path
            id="Path_2569"
            data-name="Path 2569"
            d="M7.367,16.34a.759.759,0,0,1-.42-.129.747.747,0,0,1-.325-.616V5.289A.747.747,0,0,1,7.094,4.6l8.224-3.242a.762.762,0,0,1,.693.08.747.747,0,0,1,.325.616V12.355a.744.744,0,0,1-.472.693l-8.224,3.24a.752.752,0,0,1-.273.052M8.113,5.8v8.7l6.733-2.651V3.142Z"
            transform="translate(9.83 1.935)"
            fill={props.color}
          />
          <path
            id="Path_2570"
            data-name="Path 2570"
            d="M12.283,16.338a.8.8,0,0,1-.273-.05L3.783,13.046a.747.747,0,0,1-.472-.693V2.047a.747.747,0,0,1,.325-.616.763.763,0,0,1,.693-.077l8.226,3.24a.747.747,0,0,1,.472.693V15.593a.745.745,0,0,1-.745.745M4.8,11.846,11.537,14.5V5.794L4.8,3.143Z"
            transform="translate(4.915 1.935)"
            fill={props.color}
          />
          <path
            id="Path_2571"
            data-name="Path 2571"
            d="M12.281,7.97a.742.742,0,0,1-.273-.052L3.781,4.678a.745.745,0,0,1,0-1.386L12.012.052a.742.742,0,0,1,.547,0L20.783,3.29a.747.747,0,0,1,0,1.389l-8.229,3.24a.752.752,0,0,1-.273.052M6.089,3.985l6.191,2.44,6.194-2.44-6.189-2.44Z"
            transform="translate(4.912 -0.001)"
            fill={props.color}
          />
          <path
            id="Path_2572"
            data-name="Path 2572"
            d="M4.057,21.847a.759.759,0,0,1-.42-.129.747.747,0,0,1-.325-.616V10.8a.747.747,0,0,1,.472-.693l8.224-3.24a.755.755,0,0,1,.693.077.747.747,0,0,1,.325.616V17.861a.744.744,0,0,1-.472.693l-8.224,3.24a.752.752,0,0,1-.273.052M4.8,11.3v8.7l6.733-2.651v-8.7Z"
            transform="translate(4.917 10.111)"
            fill={props.color}
          />
          <path
            id="Path_2573"
            data-name="Path 2573"
            d="M8.974,21.847a.752.752,0,0,1-.273-.052L.474,18.555A.747.747,0,0,1,0,17.861V7.556a.747.747,0,0,1,.325-.616.756.756,0,0,1,.693-.077L9.247,10.1a.747.747,0,0,1,.472.693V21.1a.747.747,0,0,1-.325.616.759.759,0,0,1-.42.129M1.493,17.355l6.736,2.651V11.3L1.493,8.651Z"
            transform="translate(0.003 10.111)"
            fill={props.color}
          />
          <path
            id="Path_2574"
            data-name="Path 2574"
            d="M8.972,13.478a.742.742,0,0,1-.273-.052L.472,10.186a.745.745,0,0,1,0-1.386L8.7,5.557a.767.767,0,0,1,.547,0L17.474,8.8a.747.747,0,0,1,0,1.389l-8.229,3.24a.752.752,0,0,1-.273.052M2.78,9.493,8.972,11.93l6.194-2.437L8.977,7.053Z"
            transform="translate(0 8.174)"
            fill={props.color}
          />
          <path
            id="Path_2575"
            data-name="Path 2575"
            d="M10.68,21.847a.759.759,0,0,1-.42-.129.747.747,0,0,1-.325-.616V10.8a.747.747,0,0,1,.472-.693l8.224-3.24a.755.755,0,0,1,.693.077.747.747,0,0,1,.325.616V17.861a.744.744,0,0,1-.472.693l-8.224,3.24a.752.752,0,0,1-.273.052M11.426,11.3v8.7l6.733-2.651v-8.7Z"
            transform="translate(14.749 10.111)"
            fill={props.color}
          />
          <path
            id="Path_2576"
            data-name="Path 2576"
            d="M15.6,21.847a.752.752,0,0,1-.273-.052L7.1,18.555a.747.747,0,0,1-.472-.693V7.556a.747.747,0,0,1,.325-.616.756.756,0,0,1,.693-.077l8.226,3.24a.747.747,0,0,1,.472.693V21.1a.747.747,0,0,1-.325.616.759.759,0,0,1-.42.129M8.115,17.355l6.736,2.651V11.3L8.115,8.651Z"
            transform="translate(9.833 10.111)"
            fill={props.color}
          />
          <path
            id="Path_2577"
            data-name="Path 2577"
            d="M15.594,13.478a.742.742,0,0,1-.273-.052l-8.226-3.24a.745.745,0,0,1,0-1.386l8.231-3.242a.767.767,0,0,1,.547,0L24.1,8.8a.747.747,0,0,1,0,1.389l-8.229,3.24a.752.752,0,0,1-.273.052M9.4,9.493l6.191,2.437,6.194-2.437L15.6,7.053Z"
            transform="translate(9.83 8.174)"
            fill={props.color}
          />
        </g>
      </g>
    </SvgIcon>
  );
};

// About / Recipes & Contributions Icon
export const ArticleCustomIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 27.414 31.346">
      <g id="Group_1765" data-name="Group 1765">
        <path
          id="Path_2555"
          data-name="Path 2555"
          d="M23.6,31.349H3.81A3.81,3.81,0,0,1,0,27.541V3.8A3.809,3.809,0,0,1,3.81,0H23.6a3.809,3.809,0,0,1,3.8,3.8V27.541a3.81,3.81,0,0,1-3.8,3.807M3.81,1.5a2.306,2.306,0,0,0-2.3,2.3V27.541a2.307,2.307,0,0,0,2.3,2.305H23.6a2.307,2.307,0,0,0,2.3-2.305V3.8a2.306,2.306,0,0,0-2.3-2.3Z"
          transform="translate(0.008 -0.001)"
          fill={props.color}
        />
        <rect
          id="Rectangle_1351"
          data-name="Rectangle 1351"
          width="26.663"
          height="1.502"
          transform="translate(0 6.823)"
          fill={props.color}
        />
        <path
          id="Path_2556"
          data-name="Path 2556"
          d="M10.618,2.855H2.325a.751.751,0,0,1,0-1.5h8.293a.751.751,0,0,1,0,1.5"
          transform="translate(2.366 2.033)"
          fill={props.color}
        />
        <path
          id="Path_2557"
          data-name="Path 2557"
          d="M21.308,12.184H2.325a.751.751,0,1,1,0-1.5H21.308a.751.751,0,0,1,0,1.5"
          transform="translate(2.366 16.055)"
          fill={props.color}
        />
        <path
          id="Path_2558"
          data-name="Path 2558"
          d="M12.754,11.011h-8.3a.751.751,0,1,1,0-1.5h8.3a.751.751,0,1,1,0,1.5"
          transform="translate(5.573 14.292)"
          fill={props.color}
        />
        <path
          id="Path_2559"
          data-name="Path 2559"
          d="M8.1,2.865a.571.571,0,0,1-.275-.075.519.519,0,0,1-.25-.15.808.808,0,0,1-.2-.526.875.875,0,0,1,.2-.551,2.2,2.2,0,0,1,.25-.15.776.776,0,0,1,.826.15.875.875,0,0,1,.2.551.808.808,0,0,1-.2.526.777.777,0,0,1-.551.225"
          transform="translate(11.078 2.03)"
          fill={props.color}
        />
        <path
          id="Path_2560"
          data-name="Path 2560"
          d="M9.011,2.858a.72.72,0,0,1-.526-.225.9.9,0,0,1-.175-.25.9.9,0,0,1-.05-.275.682.682,0,0,1,.225-.526.726.726,0,0,1,1.051,0,.682.682,0,0,1,.225.526.72.72,0,0,1-.225.526.682.682,0,0,1-.526.225"
          transform="translate(12.416 2.037)"
          fill={props.color}
        />
        <path
          id="Path_2561"
          data-name="Path 2561"
          d="M9.911,2.865a.777.777,0,0,1-.551-.225.808.808,0,0,1-.2-.526.875.875,0,0,1,.2-.551.776.776,0,0,1,.826-.15,2.2,2.2,0,0,1,.25.15.777.777,0,0,1,.225.551.72.72,0,0,1-.225.526.519.519,0,0,1-.25.15.5.5,0,0,1-.275.075"
          transform="translate(13.768 2.03)"
          fill={props.color}
        />
        <path
          id="Path_2562"
          data-name="Path 2562"
          d="M6.116,15.1a.75.75,0,0,1-.751-.751V7.539a.751.751,0,0,1,1.5,0V14.35a.75.75,0,0,1-.751.751"
          transform="translate(8.064 10.202)"
          fill={props.color}
        />
        <path
          id="Path_2563"
          data-name="Path 2563"
          d="M7.412,12.6a13.454,13.454,0,0,1-3.552-.663,1.183,1.183,0,0,1-.783-.723.73.73,0,0,1,.04-.621l.939-1.752a.485.485,0,0,1,.053-.085c1.109-1.524,1.752-1.9,2.143-2.048a3.072,3.072,0,1,1,2.2,5.737,2.912,2.912,0,0,1-1.039.155m-2.618-1.96a7.106,7.106,0,0,0,3.116.4,1.571,1.571,0,0,0,.08-2.9,1.585,1.585,0,0,0-1.2-.033c-.113.043-.553.28-1.437,1.487Zm-.513-.145h0"
          transform="translate(4.548 9.772)"
          fill={props.color}
        />
        <path
          id="Path_2564"
          data-name="Path 2564"
          d="M6.812,11.453a3.078,3.078,0,0,1-2.828-1.86c-.348-.816-.238-2.365.328-4.608A1.185,1.185,0,0,1,5,4.176a.753.753,0,0,1,.623.015l1.785.866A1.014,1.014,0,0,1,7.5,5.11C9.067,6.156,9.465,6.787,9.63,7.17A3.076,3.076,0,0,1,8.021,11.2a3.092,3.092,0,0,1-1.209.248M5.643,5.868A7.183,7.183,0,0,0,5.365,9,1.571,1.571,0,0,0,8.251,7.761c-.035-.08-.268-.518-1.542-1.374Z"
          transform="translate(5.689 6.186)"
          fill={props.color}
        />
        <path
          id="Path_2565"
          data-name="Path 2565"
          d="M8.443,11.823A3.072,3.072,0,0,1,6.984,6.045,5.577,5.577,0,0,1,9.93,5.758a.643.643,0,0,1,.1.015l1.94.433a.752.752,0,0,1,.5.375A1.19,1.19,0,0,1,12.5,7.65c-.949,2.1-1.825,3.384-2.608,3.807a3.07,3.07,0,0,1-1.452.365m.421-4.611a2.769,2.769,0,0,0-1.169.155,1.57,1.57,0,1,0,1.487,2.766A7.108,7.108,0,0,0,10.913,7.51L9.754,7.252c-.35-.03-.646-.04-.891-.04"
          transform="translate(8.065 8.577)"
          fill={props.color}
        />
      </g>
    </SvgIcon>
  );
};

// Component that renders a row with an icon and a title.
interface IconTitleProps {
  Icon: React.FC<SvgIconProps>;
  title: string;
  color: string;
}

export const IconTitle: React.FC<IconTitleProps> = ({ Icon, title, color }) => {
  return (
    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
      <Icon sx={{ color: color, mr: 1 }} />
      <Typography
        variant="h6"
        sx={{
          color: color,
          fontWeight: 600,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

// Components that render icons for location and school
interface LocationTitleProps {
  location?: string;
}

export const LocationTitle: React.FC<LocationTitleProps> = ({ location }) => {
  const theme = useTheme();

  if (!location) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 1,
      }}
    >
      <LocationOnIcon
        sx={{
          fontSize: 16,
          color: theme.palette.materiom.charcoal,
          mr: 0.5,
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {location}
      </Typography>
    </Box>
  );
};

interface SchoolTitleProps {
  institute?: string;
}

export const SchoolTitle: React.FC<SchoolTitleProps> = ({ institute }) => {
  const theme = useTheme();

  if (!institute) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
      }}
    >
      <SchoolIcon
        sx={{
          fontSize: 16,
          color: theme.palette.materiom.charcoal,
          mr: 0.5,
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {institute}
      </Typography>
    </Box>
  );
};
